import { Col, Collapse, DatePicker, Form, Input, Row } from 'antd';
import moment from 'moment';
import React, { Dispatch, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import ClearFilterBtn from '../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../components/CollapseFilter';
import FilterBtn from '../../../../components/FilterBtn';
import FilterContainer from '../../../../components/FilterContainer';
import {SelectParceiroDepositante} from '../../../../components/SelectParceiroDepositante';
import SelectNumNota from '../../../../components/SelectNumNota';
import SelectNumUnico from '../../../../components/SelectNumUnico';
import SelectPagadorArmazenagem from '../../../../components/SelectPagadorArmazenagem';
import SelectStatus from '../../../../components/SelectStatus';
import SelectTransportadoraParceira from '../../../../components/SelectTransportadoraParceira';
import TextFilter from '../../../../components/TextFilter';
import CollapseTitle from '../../../../components/TitleCollapseFilter';
import { ApplicationState } from '../../../../store';
import {
  cleanStateMoviSaida,
  filterSolicitacoesRetorno,
  loadRequest,
} from '../../../../store/ducks/solicitacoesRetorno/actions';
import { CALENDAR_LOCALE } from '../../../../utils/calendar-locale';
import { maskDateTime } from '../../../../utils/mask';
import { SelectDepositante } from 'components/SelectDepositante';
import { ROLE } from 'utils/roles';

const { RangePicker } = DatePicker;
const { Panel } = Collapse;

const Filter: React.FC = () => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const pagCurrent = useSelector(
    (state: ApplicationState) => state.SolicitacoesRetorno.pagination.current
  );
  const sorter = useSelector((state: ApplicationState) => state.SolicitacoesRetorno.sorter);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil)

  const [filter, setFilter] = useState<object | undefined | any>();
  const dispatch = useDispatch<Dispatch<Action>>();

  const clearFilter = () => {
    dispatch(cleanStateMoviSaida());
    localStorage.removeItem(`pagadorArmazenagem${window.location.pathname}`);
    localStorage.removeItem(`depositante${window.location.pathname}`);
    localStorage.removeItem(`codDepositante${window.location.pathname}`);
    localStorage.removeItem(`codTransportadora${window.location.pathname}`);
    localStorage.removeItem(`numNota${window.location.pathname}`);
    localStorage.removeItem(`nuNota${window.location.pathname}`);
    localStorage.removeItem(`status${window.location.pathname}`);
    localStorage.removeItem(`dataRangeInicial${window.location.pathname}`);
    localStorage.removeItem(`dataRangeInicio${window.location.pathname}`);
    localStorage.removeItem(`dataRangeFim${window.location.pathname}`);
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    dispatch(loadRequest({}, inscricaoAtiva, cddAtivo?.codCdd, sorter));
  };

  const onFilter = (values: any) => {
    const { dtLancamento, dtEmissao, ...rest } = values;

    let periodoSolicitacaoInicio, periodoSolicitacaoFim;

    if (dtLancamento) [periodoSolicitacaoInicio, periodoSolicitacaoFim] = dtLancamento;

    localStorage.setItem(
      window.location.pathname + 'valuesFilter',
      JSON.stringify({
        ...rest,
        periodoSolicitacaoInicio: localStorageItensPersist.periodoSolicitacaoInicio
          ? localStorageItensPersist.periodoSolicitacaoInicio
          : periodoSolicitacaoInicio === undefined
          ? undefined
          : maskDateTime(periodoSolicitacaoInicio),
        periodoSolicitacaoFim: localStorageItensPersist.periodoSolicitacaoFim
          ? localStorageItensPersist.periodoSolicitacaoFim
          : periodoSolicitacaoFim === undefined
          ? undefined
          : maskDateTime(periodoSolicitacaoFim),
      })
    );

    setFilter({
      ...rest,
      periodoSolicitacaoInicio: periodoSolicitacaoInicio
        ? maskDateTime(periodoSolicitacaoInicio)
        : localStorageItensPersist.periodoSolicitacaoInicio,
      periodoSolicitacaoFim: periodoSolicitacaoFim
        ? maskDateTime(periodoSolicitacaoFim)
        : localStorageItensPersist.periodoSolicitacaoFim,
    });
  };

  const localStorageItensPersist: any = JSON.parse(
    localStorage.getItem(window.location.pathname + `valuesFilter`) || '{}'
  );

  const { periodoSolicitacaoInicio, periodoSolicitacaoFim } = localStorageItensPersist;

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      sorter={sorter}
      loadRequest={loadRequest}
      saveFilter={filterSolicitacoesRetorno}
      saveLocalStorage={'persist:SolicitacoesRetorno'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer
          onFilter={onFilter}
          initialValues={{
            ...localStorageItensPersist,
            periodoSolicitacaoInicio: periodoSolicitacaoInicio
              ? moment(periodoSolicitacaoInicio, 'DD/MM/YYYY')
              : undefined,
            periodoSolicitacaoFim: periodoSolicitacaoFim
              ? moment(periodoSolicitacaoFim, 'DD/MM/YYYY')
              : undefined,
          }}
        >
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectNumUnico setNuNota={() => {}} />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <SelectNumNota label="Número do pedido" setNumNotas={() => {}} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectPagadorArmazenagem setFiltro={filter} setPagArmazenagem={() => {}} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectStatus />
            </Col>
          </Row>

          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectTransportadoraParceira />
            </Col>
            <Col md={6} sm={24} xs={24}>
              {perfil === ROLE.DEPOSITANTE
                ? <SelectParceiroDepositante  />
                : <SelectDepositante />
              }
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Período solicitação</TextFilter>} name="dtLancamento">
                {periodoSolicitacaoInicio === undefined ? (
                  <RangePicker
                    style={{ width: '100%' }}
                    locale={CALENDAR_LOCALE}
                    format="DD/MM/YYYY"
                  />
                ) : (
                  <RangePicker
                    style={{ width: '100%' }}
                    locale={CALENDAR_LOCALE}
                    format="DD/MM/YYYY"
                    defaultValue={[
                      moment(periodoSolicitacaoInicio, 'DD/MM/YYYY'),
                      moment(periodoSolicitacaoFim, 'DD/MM/YYYY'),
                    ]}
                  />
                )}
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Usuário solicitante</TextFilter>} name="nomeUsu">
                <Input placeholder="Digite o nome do usuário solicitante" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
